/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

export const awsmobile = {
    "aws_project_region": "eu-south-1",
    "aws_content_delivery_bucket": "portale-20231011093714-hostingbucket-portale",
    "aws_content_delivery_bucket_region": "eu-south-1",
    "aws_content_delivery_url": "https://d1otbegfnt8mk7.cloudfront.net",
    "aws_cognito_region": "eu-south-1",
    "aws_user_pools_id": "eu-south-1_mSi5ZPr63",
    "aws_user_pools_web_client_id": "69e26p12e88pe7ggla7tpa5rfn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
